import {TableStyles} from 'react-data-table-component';

/**
 * Header styling for every report's drill-down table.
 *
 * Without this the column headings render in the same weight and colour as the
 * rows and read as just another row. This is the same header treatment the
 * other list screens use (components/datatable/Table.tsx): a tinted band, bold
 * upper-case labels with a little letter spacing.
 */
export const reportTableStyles: TableStyles = {
  head: {
    style: {
      color: '#5E5873',
      fontSize: '12px',
      fontWeight: 700
    }
  },
  headRow: {
    style: {
      backgroundColor: '#F7F7F8',
      minHeight: '44px',
      borderBottomWidth: '2px',
      borderBottomColor: '#DEE2E6',
      borderBottomStyle: 'solid'
    }
  },
  headCells: {
    style: {
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    }
  }
};

export default reportTableStyles;
